// ═══════════════════════════════════════════════════════════════════
//  modules/auth/Login.js
//  Login
// ═══════════════════════════════════════════════════════════════════

import { useState } from "react";
import { BouxImg } from "../../composants/BouxImg";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";

export function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async () => {
    setError("");
    if (!email || !password) { setError("Email et mot de passe requis"); return; }
    setLoading(true);
    try {
      const res = await fetch(`${API_BASE}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password }),
      });
      const data = await res.json();
      if (!res.ok) { setError(data.error || "Erreur de connexion"); setLoading(false); return; }
      window.location.href = `${API_BASE}/api/auth/discord?tempToken=${data.tempToken}`;
    } catch {
      setError("Impossible de contacter le serveur");
      setLoading(false);
    }
  };

  return (
    <div style={{ minHeight: "100vh", background: THEME.bg, display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "Inter, -apple-system, sans-serif", padding: 20, boxSizing: "border-box" }}>
      <div style={{ width: "100%", maxWidth: 420, display: "flex", flexDirection: "column", gap: 24, alignItems: "center" }}>
        <div style={{ textAlign: "center" }}>
          <div style={{ marginBottom: 8, display: "flex", justifyContent: "center" }}><BouxImg width={110} /></div>
          <div style={{ color: THEME.gold, fontSize: 28, fontWeight: 800, letterSpacing: 2 }}>BOXORIA</div>
          <div style={{ color: THEME.textMuted, fontSize: 13, marginTop: 4 }}>· Intranet Staff ·</div>
        </div>
        <div style={{ width: "100%", background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 14, padding: 32, display: "flex", flexDirection: "column", gap: 20 }}>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <label style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 600 }}>EMAIL</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} placeholder="ton.email@orialis.fr"
              style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 14, outline: "none" }} />
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
            <label style={{ color: THEME.textMuted, fontSize: 12, fontWeight: 600 }}>MOT DE PASSE</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} onKeyDown={(e) => e.key === "Enter" && handleLogin()} placeholder="••••••••••••"
              style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8, padding: "10px 14px", color: THEME.text, fontSize: 14, outline: "none" }} />
          </div>
          {error && <div style={{ color: THEME.red, fontSize: 13 }}>{error}</div>}
          <button onClick={handleLogin} disabled={loading}
            style={{ background: THEME.accent, border: "none", color: "white", borderRadius: 8, padding: "12px", cursor: loading ? "not-allowed" : "pointer", fontSize: 15, fontWeight: 700, opacity: loading ? 0.6 : 1 }}>
            {loading ? "Connexion..." : "Continuer →"}
          </button>
        </div>
        <div style={{ color: THEME.textDim, fontSize: 12 }}>Accès réservé à l'équipe Admin de Boxoria · HTTPS sécurisé</div>
      </div>
    </div>
  );
}
